export default __webpack_public_path__ + "static/media/frg--castle-hill.ee878fcd.png";